export const sizes = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl'
};
export const sizeMap = new Map([[sizes.xs, {
  width: 16,
  height: 16
}], [sizes.sm, {
  width: 20,
  height: 20
}], [sizes.md, {
  width: 24,
  height: 24
}], [sizes.lg, {
  width: 32,
  height: 32
}], [sizes.xl, {
  width: 48,
  height: 48
}]]);